var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-error"},[_c('img',{attrs:{"src":require("../assets/images/receiptLotteryLose@3x.png"),"alt":"error"}}),_c('div',{staticStyle:{"margin-top":"30px"}},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }